const grade_5= {
    label: "Grade 5",
    subjects: {

           "applied_design_4": {
   "label": "Applied Design (Grade 5)",
    "topics": [
      { "value": "Understanding_Context", "label": "Understanding Context" },
      { "value": "defining", "label": "Defining" },
      { "value": "ideating", "label": "Ideating" },
      { "value": "prototyping", "label": "Prototyping" },
      { "value": "testing", "label": "Testing" },
      { "value": "making", "label": "Making" },
      { "value": "sharing", "label": "Sharing" },
      { "value": "applied_skills", "label": "Applied Skills" },
      { "value": "applied_technologies", "label": "Applied Technologies" }
    ],
    "competencies": {
      "core": [
      { "value": "Understanding_Context", "label": "Understanding Context" },
      { "value": "defining", "label": "Defining" },
      { "value": "ideating", "label": "Ideating" },
      { "value": "prototyping", "label": "Prototyping" },
      { "value": "testing", "label": "Testing" },
      { "value": "making", "label": "Making" },
      { "value": "sharing", "label": "Sharing" },
      { "value": "applied_skills", "label": "Applied Skills" },
      { "value": "applied_technologies", "label": "Applied Technologies" }
      ],
 
      "sub": {
        "applied_design": [
          /* -------------------- Defining -------------------- */
          {
            "value": "gather_information",
            "label": "Gather information about or from potential users"
          },
          {
            "value": "choose_design_opportunity",
            "label": "Choose a design opportunity"
          },
          {
            "value": "identify_key_features",
            "label": "Identify key features or user requirements"
          },
          {
            "value": "identify_main_objective",
            "label": "Identify the main objective for the design and any constraints"
          },

          /* -------------------- Ideating -------------------- */
          {
            "value": "generate_potential_ideas",
            "label": "Generate potential ideas and add to others’ ideas"
          },
          {
            "value": "screen_ideas",
            "label": "Screen ideas against the objective and constraints"
          },
          {
            "value": "choose_idea_to_pursue",
            "label": "Choose an idea to pursue"
          },

          /* -------------------- Prototyping -------------------- */
          {
            "value": "outline_general_plan",
            "label": "Outline a general plan, identifying tools and materials"
          },
          {
            "value": "construct_first_version",
            "label": "Construct a first version of the product, making changes to tools, materials, and procedures as needed"
          },
          {
            "value": "record_iterations",
            "label": "Record iterations of prototyping"
          },

          /* -------------------- Testing -------------------- */
          {
            "value": "test_product",
            "label": "Test the product"
          },
          {
            "value": "gather_peer_feedback",
            "label": "Gather peer feedback and inspiration"
          },
          {
            "value": "make_changes_and_test_again",
            "label": "Make changes and test again, repeating until satisfied with the product"
          },

          /* -------------------- Making -------------------- */
          {
            "value": "construct_final_product",
            "label": "Construct the final product, incorporating planned changes"
          },

          /* -------------------- Sharing -------------------- */
          {
            "value": "decide_sharing",
            "label": "Decide on how and with whom to share their product"
          },
          {
            "value": "demonstrate_product_and_process",
            "label": "Demonstrate their product and describe their process"
          },
          {
            "value": "determine_product_success",
            "label": "Determine whether their product meets the objective and contributes to the individual, family, community, and/or environment"
          },
          {
            "value": "reflect_on_design_thinking",
            "label": "Reflect on their design thinking and processes, and their ability to work effectively both as individuals and collaboratively in a group, including their ability to share and maintain a co-operative workspace"
          },
          {
            "value": "identify_new_design_issues",
            "label": "Identify new design issues"
          }
        ],

        /* -------------------- Applied Skills -------------------- */
        "applied_skills": [
          {
            "value": "safe_use_tools_awareness",
            "label": "Use materials, tools, and technologies in a safe manner, and with awareness of the safety of others, in both physical and digital environments"
          },
          {
            "value": "identify_and_develop_skills",
            "label": "Identify the skills required for a task and develop those skills as needed"
          }
        ],

        /* -------------------- Applied Technologies -------------------- */
        "applied_technologies": [
          {
            "value": "use_familiar_tools",
            "label": "Use familiar tools and technologies to extend their capabilities when completing a task"
          },
          {
            "value": "choose_appropriate_technologies",
            "label": "Choose appropriate technologies to use for specific tasks"
          },
          {
            "value": "willing_to_learn_new_technologies",
            "label": "Demonstrate a willingness to learn new technologies as needed"
          }
        ]
      }
    }
  }
,   
      
  "arts_5": {
    "label": "Arts Education (Grade 5)",
   topics: [
        { value: "Expanding and Creating", label: "Expanding and Creating" },
        { value: "reasoning_reflecting", label: "Reasoning and Reflecting" },
        { value: "communicating_documenting", label: "Communicating and Documenting" },
        // { value: "connecting_expanding", label: "Connecting and Expanding" }
      ],
      competencies: {
        core: [
          { value: "Exploring", label: "Expanding and Creating" },
          { value: "Reasoning", label: "Reasoning and Reflecting" },
          { value: "Communicating", label: "Communicating and Documenting" },
          // { value: "Connecting", label: "Connecting and Expanding" }
        ],

      "sub": {
        "exploring_creating": [
          {
            "value": "select_art_elements_processes_grade5",
            "label": "Intentionally select artistic elements, processes, materials, movements, technologies, tools, techniques, and environments to express meaning"
          },
          {
            "value": "create_artistic_works_grade5",
            "label": "Create artistic works collaboratively and individually using ideas inspired by imagination, inquiry, experimentation, and purposeful play"
          },
          {
            "value": "explore_identity_place_culture_belonging_grade5",
            "label": "Explore connections to identity, place, culture, and belonging through creative expression"
          },
          {
            "value": "explore_cultures_relationships_arts_grade5",
            "label": "Explore a range of cultures and the relationships among cultures, societies, and the arts"
          }
        ],

        "reasoning_reflecting": [
          {
            "value": "observe_listen_predict_tools_grade5",
            "label": "Observe, listen, describe, inquire, and predict how artists use processes and tools"
          },
          {
            "value": "develop_refine_ideas_skills_grade5",
            "label": "Develop and refine ideas, processes, and technical skills to improve the quality of artistic creations"
          },
          {
            "value": "reflect_creative_process_individual_group_grade5",
            "label": "Reflect on creative processes as an individual and as a group"
          },
          {
            "value": "connect_other_learning_grade5",
            "label": "Connect knowledge and skills from other areas of learning in planning, creating, interpreting, and analyzing works of art"
          }
        ],

        "communicating_documenting": [
          {
            "value": "interpret_communicate_symbols_grade5",
            "label": "Interpret and communicate ideas using symbols and elements to express meaning through the arts"
          },
          {
            "value": "express_feelings_ideas_arts_grade5",
            "label": "Express feelings, ideas, and experiences through the arts"
          },
          {
            "value": "describe_respond_artists_intent_grade5",
            "label": "Describe and respond to works of art and explore artists’ intent"
          }
        ],

        "connecting_expanding": [
          {
            "value": "experience_document_present_grade5",
            "label": "Experience, document, and present creative works in a variety of ways"
          },
          {
            "value": "examine_relationships_arts_world_grade5",
            "label": "Examine relationships between the arts and the wider world"
          },
          {
            "value": "adapt_skills_new_contexts_grade5",
            "label": "Adapt learned skills, understandings, and processes for new contexts and audiences"
          },
          {
            "value": "demonstrate_sophisticated_engagement_grade5",
            "label": "Demonstrate increasingly sophisticated engagement of curricular content"
          }
        ]
      }
    }
  }
,  

  career_education_5: {
        label: 'Career Education (Grade 5) ',
        topics: [],
        competencies: {
          core: [
            { value: 'examine', label: 'Examine' },
            { value: 'interact', label: 'Interact' },
            { value: 'experience', label: 'Experience' },
            { value: 'initiate', label: 'Initiate' },
            { value: 'share', label: 'Share' }
          ],
          sub: {
            examine: [
              { value: 'identify_and_appreciate_personal_attributes', label: 'Identify and appreciate their personal attributes, skills, interests, and accomplishments and their growth over time' },
              { value: 'demonstrate_respect_for_differences', label: 'Demonstrate respect for differences in the classroom' },
              { value: 'appreciate_the_influence_of_peer_relationships', label: 'Appreciate the influence of peer relationships, family, and community on personal choices and goals' }
            ],
            interact: [
              { value: 'use_innovative_thinking', label: 'Use innovative thinking when solving problems' },
              { value: 'make_connections_between_effective_work_habits_and_success', label: 'Make connections between effective work habits and success' },
              { value: 'recognize_the_need_for_others_who_can_support', label: 'Recognize the need for others who can support their learning and personal growth' }
            ],
            experience: [
              { value: 'set_realistic_short_and_longer_term_learning_goals', label: 'Set realistic short- and longer-term learning goals, define a path, and monitor progress' },
              { value: 'demonstrate_safe_behaviours', label: 'Demonstrate safe behaviours in a variety of environments' }
            ],
            initiate: [
              { value: 'recognize_the_intersection_of_personal_and_public_digital_identities', label: 'Recognize the intersection of their personal and public digital identities and the potential for both positive and negative consequences' },
              { value: 'question_self_and_others_about_the_role_of_technology', label: 'Question self and others about the role of technology in the changing workplace' }
            ],
            share: [
              { value: 'share_ideas_and_reflect_on_how_experiences_contribute', label: 'Share ideas and reflect on how experiences contribute to personal and collective growth (implied from the learning cycle)' }
            ]
          }
        }
      },
      
  "english_5": {
    "label": "English Language Arts (Grade 5)",
    "topics": [
      { "value": "comprehend_connect", "label": "Comprehend and Connect (Reading, Listening, Viewing)" },
      { "value": "create_communicate", "label": "Create and Communicate (Writing, Speaking, Representing)" }
    ],
    "competencies": {
      "core": [
        { "value": "comprehend_connect", "label": "Comprehend and Connect (reading, listening, viewing)" },
        { "value": "create_communicate", "label": "Create and Communicate (writing, speaking, representing)" }
      ],
      "sub": {
        "comprehend_connect": [
          {
            "value": "access_information_ideas",
            "label": "Access information and ideas from a variety of sources and from prior knowledge to build understanding"
          },
          {
            "value": "use_variety_comprehension_strategies",
            "label": "Use a variety of comprehension strategies before, during, and after reading, listening, or viewing to guide inquiry and deepen understanding of text"
          },
          {
            "value": "synthesize_ideas_variety_sources",
            "label": "Synthesize ideas from a variety of sources to build understanding (Grade 5–9)"
          },
          {
            "value": "consider_purposes_audiences_perspectives",
            "label": "Consider different purposes, audiences, and perspectives in exploring texts (Grade 4–5)"
          },
          {
            "value": "apply_variety_thinking_skills",
            "label": "Apply a variety of thinking skills to gain meaning from texts (Grade 4–5)"
          },
          {
            "value": "identify_context_perspective_voice",
            "label": "Identify how differences in context, perspectives, and voice influence meaning in texts (Grade 4–5)"
          },
          {
            "value": "explain_role_of_language_identity",
            "label": "Explain the role of language in personal, social, and cultural identity"
          },
          {
            "value": "use_experience_connect_deepen",
            "label": "Use personal experience and knowledge to connect to text and develop understanding of self, community, and world"
          },
          {
            "value": "respond_personal_creative",
            "label": "Respond to text in personal and creative ways (Grade 4–5)"
          },
          {
            "value": "recognize_literary_elements_devices",
            "label": "Recognize how literary elements, techniques, and devices enhance meaning in texts (Grade 4–5)"
          },
          {
            "value": "understand_role_organization",
            "label": "Show an increasing understanding of the role of organization in meaning (Grade 4–5)"
          },
          {
            "value": "awareness_fp_oral_tradition",
            "label": "Demonstrate awareness of the oral tradition in First Peoples cultures and the purposes of First Peoples texts (Grade 4–5)"
          },
          {
            "value": "identify_fp_story_land",
            "label": "Identify how story in First Peoples cultures connects people to land (Grade 4–5)"
          }
        ],

        "create_communicate": [
          {
            "value": "exchange_ideas_perspectives",
            "label": "Exchange ideas and perspectives to build shared understanding (K-5)"
          },
          {
            "value": "writing_design_processes",
            "label": "Use writing and design processes to plan, develop, and create texts for a variety of purposes and audiences (Grade 4–5)"
          },
          {
            "value": "use_language_creative_playful",
            "label": "Use language in creative and playful ways to develop style (Grade 4–5)"
          },
          {
            "value": "communicate_paragraphs_conventions",
            "label": "Communicate in writing using paragraphs and applying conventions of Canadian spelling, grammar, and punctuation"
          },
          {
            "value": "develop_apply_word_knowledge",
            "label": "Develop and apply expanding word knowledge (Grade 3–5)"
          },
          {
            "value": "use_oral_storytelling_processes",
            "label": "Use oral storytelling processes (Grade 3–5)"
          },
          {
            "value": "transform_ideas_create_original_texts",
            "label": "Transform ideas and information to create original texts (Grade 4–9)"
          }
        ]
      }
    }
  }

,
 "math_5": {
    "label": "Mathematics (Grade 5)",
    "topics": [
      { "value": "reasoning_analyzing", "label": "Reasoning and Analyzing" },
      { "value": "understanding_solving", "label": "Understanding and Solving" },
      { "value": "communicating_representing", "label": "Communicating and Representing" },
      { "value": "connecting_reflecting", "label": "Connecting and Reflecting" }
    ],

    "competencies": {
      "core": [
        { "value": "reasoning_analyzing", "label": "Reasoning and Analyzing" },
        { "value": "understanding_solving", "label": "Understanding and Solving" },
        { "value": "communicating_representing", "label": "Communicating and Representing" },
        { "value": "connecting_reflecting", "label": "Connecting and Reflecting" }
      ],

      "sub": {
        "reasoning_analyzing": [
          {
            "value": "use_reasoning_make_connections_k5",
            "label": "Use reasoning to explore and make connections"
          },
          {
            "value": "estimate_reasonably_k5",
            "label": "Estimate reasonably"
          },
          {
            "value": "develop_mental_math_strategies_k5",
            "label": "Develop mental math strategies and abilities to make sense of quantities"
          },
          {
            "value": "use_technology_explore_math_k5",
            "label": "Use technology to explore mathematics"
          }
        ],

        "understanding_solving": [
          {
            "value": "model_mathematics_context_k5",
            "label": "Model mathematics in contextualized experiences"
          },
          {
            "value": "apply_understanding_play_inquiry_k5",
            "label": "Develop, demonstrate, and apply mathematical understanding through play, inquiry, and problem solving"
          },
          {
            "value": "visualize_explore_math_concepts_k5",
            "label": "Visualize to explore mathematical concepts"
          },
          {
            "value": "use_multiple_problem_solving_strategies_k5",
            "label": "Develop and use multiple strategies to engage in problem solving"
          },
          {
            "value": "connect_problem_solving_local_culture_k5",
            "label": "Engage in problem-solving experiences connected to place, story, cultural practices, and perspectives relevant to local First Peoples communities, the local community, and other cultures"
          }
        ],

        "communicating_representing": [
          {
            "value": "communicate_math_thinking_k5",
            "label": "Communicate mathematical thinking in many ways"
          },
          {
            "value": "use_math_vocabulary_k5",
            "label": "Use mathematical vocabulary and language to contribute to mathematical discussions"
          },
          {
            "value": "explain_justify_math_ideas_k5",
            "label": "Explain and justify mathematical ideas and decisions"
          },
          {
            "value": "represent_math_ideas_k5",
            "label": "Represent mathematical ideas in concrete, pictorial, and symbolic forms"
          }
        ],

        "connecting_reflecting": [
          {
            "value": "reflect_math_thinking_k5",
            "label": "Reflect on mathematical thinking"
          },
          {
            "value": "connect_math_concepts_k5",
            "label": "Connect mathematical concepts to each other and to other areas and personal interests"
          },
          {
            "value": "incorporate_first_peoples_perspectives_k5",
            "label": "Incorporate First Peoples worldviews and perspectives to make connections to mathematical concepts"
          }
        ]
      }
    }
  }
,
 "phe_5": {
    "label": "Physical and Health Education (Grade 5)",
    "topics": [
      { "value": "physical_literacy", "label": "Physical Literacy" },
      { "value": "healthy_active_living", "label": "Healthy and Active Living" },
      { "value": "social_community_health", "label": "Social and Community Health" },
      { "value": "mental_well_being", "label": "Mental Well-Being" }
    ],

    "competencies": {
      "core": [
        { "value": "physical_literacy", "label": "Physical Literacy" },
        { "value": "healthy_active_living", "label": "Healthy and Active Living" },
        { "value": "social_community_health", "label": "Social and Community Health" },
        { "value": "mental_well_being", "label": "Mental Well-Being" }
      ],

      "sub": {
        "physical_literacy": [
          {
            "value": "develop_apply_movement_skills_5",
            "label": "Develop and apply fundamental movement skills in a variety of physical activities and environments (3–5)"
          },
          {
            "value": "apply_movement_concepts_strategies_5",
            "label": "Apply movement concepts and strategies in different physical activities (3–4)"
          },
          {
            "value": "apply_exertion_monitoring_5",
            "label": "Apply methods of monitoring exertion in physical activity (2–4)"
          },
          {
            "value": "safety_fair_play_leadership_5",
            "label": "Develop and demonstrate safety, fair play, and leadership in physical activities (K–9)"
          },
          {
            "value": "identify_preferred_activities_5",
            "label": "Identify preferred types of physical activity (4–9)"
          }
        ],

        "healthy_active_living": [
          {
            "value": "participate_daily_activity_5",
            "label": "Participate daily in physical activity at moderate to vigorous intensity levels (K–6)"
          },
          {
            "value": "opportunities_challenges_participation_5",
            "label": "Identify opportunities and challenges to participation in physical activity (4–5)"
          },
          {
            "value": "healthy_eating_relationship_health_5",
            "label": "Describe the relationship between healthy eating and overall health (4–6)"
          },
          {
            "value": "healthy_eating_strategies_5",
            "label": "Identify and describe strategies for making healthy eating choices (3–5)"
          },
          {
            "value": "access_health_information_5",
            "label": "Describe ways to access health information and support services (2–5)"
          },
          {
            "value": "personal_healthy_living_strategies_5",
            "label": "Describe strategies for pursuing personal healthy-living goals (4–5)"
          }
        ],

        "social_community_health": [
          {
            "value": "discrimination_stereotyping_bullying_5",
            "label": "Describe and assess strategies for responding to discrimination, stereotyping, and bullying (4–7)"
          },
          {
            "value": "positive_relationships_5",
            "label": "Apply strategies for developing and maintaining positive relationships (3–5)"
          },
          {
            "value": "factors_influencing_social_interactions_5",
            "label": "Identify and describe factors that influence positive social interactions"
          },
          {
            "value": "promote_safe_caring_environments_5",
            "label": "Describe and assess strategies for promoting safe and caring school, home, and community environments (4–5)"
          }
        ],

        "mental_well_being": [
          {
            "value": "strategies_promote_mental_wellbeing_5",
            "label": "Describe and assess strategies for promoting mental well-being (4–5)"
          },
          {
            "value": "puberty_changes_5",
            "label": "Describe physical, emotional, and social changes that occur during puberty"
          },
          {
            "value": "manage_changes_puberty_5",
            "label": "Identify and apply strategies to manage changes during puberty"
          },
          {
            "value": "factors_influencing_self_identity_5",
            "label": "Describe factors that influence self-identity"
          }
        ]
      }
    }
  },
    
     
      science_5: {
        label: "Science (Grade 5)",
        topics: [
          { value: "ecosystems", label: "Ecosystems" },
          { value: "forces_motion", label: "Forces and Motion" },
          { value: "matter_energy", label: "Matter and Energy" }
        ],
        competencies: {
          core: [
            { value: "questioning_predicting", label: "Questioning and Predicting" },
            { value: "planning_conducting", label: "Planning and Conducting" },
            { value: "processing_analyzing", label: "Processing and Analyzing Data and Information" },
            { value: "evaluating", label: "Evaluating" },
            { value: "applying_innovating", label: "Applying and Innovating" },
            { value: "communicating", label: "Communicating" }
          ],
          sub: {
            questioning_predicting: [
              { value: "sustained_curiosity", label: "Demonstrate a sustained curiosity about a scientific topic or problem of personal interest" },
              { value: "make_observations", label: "Make observations in familiar or unfamiliar contexts" },
              { value: "identify_questions", label: "Identify questions to answer or problems to solve through scientific inquiry" },
              { value: "predict_findings", label: "Make predictions about the findings of their inquiry" }
            ],

            planning_conducting: [
              { value: "plan_investigations", label: "With support, plan appropriate investigations to answer their questions or solve problems" },
              { value: "variables_fair_test", label: "Decide which variable should be changed and measured for a fair test" },
              { value: "choose_data", label: "Choose appropriate data to collect" },
              { value: "use_equipment_safely", label: "Use equipment and materials safely, identifying potential risks" }
            ],

            processing_analyzing: [
              { value: "represent_data_methods", label: "Construct and use a variety of methods, including tables, graphs, and digital technologies, to represent patterns or relationships in data" },
              { value: "identify_patterns", label: "Identify patterns and connections in data" },
              { value: "compare_with_predictions", label: "Compare data with predictions and develop explanations for results" }
            ],

            evaluating: [
              { value: "evaluate_fair_tests", label: "Evaluate whether investigations were fair tests" },
              { value: "sources_of_error", label: "Identify possible sources of error" },
              { value: "improve_methods", label: "Suggest improvements to investigation methods" },
              { value: "identify_assumptions", label: "Identify assumptions in secondary sources" },
              { value: "appreciate_evidence", label: "Demonstrate understanding and appreciation of evidence" },
              { value: "social_ethical_environmental", label: "Identify social, ethical, and environmental implications of investigations" }
            ],

            applying_innovating: [
              { value: "care_self_community", label: "Contribute to care for self, others, and community through personal or collaborative approaches" },
              { value: "cooperative_design", label: "Co-operatively design projects" },
              { value: "apply_learning", label: "Transfer and apply learning to new situations" },
              { value: "generate_new_ideas", label: "Generate and introduce new or refined ideas when problem solving" }
            ],

            communicating: [
              { value: "communicate_variety_ways", label: "Communicate ideas, explanations, and processes in a variety of ways" },
              { value: "express_reflect_place", label: "Express and reflect on personal, shared, or others’ experiences of place" }
            ]
          }
        }
      },
      core_french_5: {
        label: 'Core French',
        topics: [],
        competencies: {
          core: [
            { value: 'thinking_and_communicating', label: 'Thinking and Communicating' },
            { value: 'personal_and_social_awareness', label: 'Personal and Social Awareness' }
          ],
          sub: {
            thinking_and_communicating: [
              { value: 'comprehend_key_information', label: 'Comprehend key information in slow, clear speech and other simple texts' },
              { value: 'comprehend_simple_stories', label: 'Comprehend simple stories' },
              { value: 'interpret_non_verbal_cues', label: 'Interpret non-verbal cues to increase comprehension' },
              { value: 'use_various_strategies', label: 'Use various strategies to support communication' },
              { value: 'seek_clarification', label: 'Seek clarification of meaning' },
              { value: 'recognize_intonation_meaning', label: 'Recognize the relationships between intonation and meaning' },
              { value: 'respond_to_simple_commands', label: 'Respond to simple commands and instructions' },
              { value: 'participate_in_simple_interactions', label: 'Participate, with support, in simple interactions involving everyday situations' },
              { value: 'express_and_comprehend_others', label: 'Express themselves and comprehend others through various modes of presentation' }
            ],
            personal_and_social_awareness: [
              { value: 'identify_francophone_communities', label: 'Identify Francophone communities across Canada' },
              { value: 'demonstrate_awareness_of_connections', label: 'Demonstrate awareness of connections between First Peoples communities and the French language' },
              { value: 'identify_francophone_cultural_festival', label: 'Identify a Francophone cultural festival or celebration in Canada' }
            ]
          }
        }
      },
    
    
  "social_studies_5": {
    "label": "Social Studies (Grade 5)",
    "topics": [
      { "value": "inquiry", "label": "Inquiry" },
      { "value": "significance", "label": "Significance" },
      { "value": "evidence", "label": "Evidence" },
      { "value": "continuity_change", "label": "Continuity and Change" },
      { "value": "cause_consequence", "label": "Cause and Consequence" },
      { "value": "perspective", "label": "Perspective" },
      { "value": "ethical_judgement", "label": "Ethical Judgement" }
    ],

    "competencies": {
      "core": [
        { "value": "inquiry", "label": "Inquiry" },
        { "value": "significance", "label": "Significance" },
        { "value": "evidence", "label": "Evidence" },
        { "value": "continuity_change", "label": "Continuity and Change" },
        { "value": "cause_consequence", "label": "Cause and Consequence" },
        { "value": "perspective", "label": "Perspective" },
        { "value": "ethical_judgement", "label": "Ethical Judgement" }
      ],

      "sub": {
        "inquiry": [
          {
            "value": "inquiry_process_ss5_6",
            "label": "Use Social Studies inquiry processes and skills to ask questions; gather, interpret, and analyze ideas; and communicate findings and decisions"
          },
          {
            "value": "develop_plan_action_ss5_6",
            "label": "Develop a plan of action to address a selected problem or issue"
          }
        ],

        "significance": [
          {
            "value": "construct_arguments_significance_ss5_6",
            "label": "Construct arguments defending the significance of individuals/groups, places, events, or developments"
          }
        ],

        "evidence": [
          {
            "value": "ask_corroborate_conclude_sources_ss5_6",
            "label": "Ask questions, corroborate inferences, and draw conclusions about the content and origins of a variety of sources, including mass media"
          }
        ],

        "continuity_change": [
          {
            "value": "sequence_recognize_continuity_change_ss5_6",
            "label": "Sequence objects, images, or events, and recognize the positive and negative aspects of continuities and changes in the past and present"
          }
        ],

        "cause_consequence": [
          {
            "value": "differentiate_causes_consequences_ss5_6",
            "label": "Differentiate between short- and long-term causes, and intended and unintended consequences, of events, decisions, or developments"
          }
        ],

        "perspective": [
          {
            "value": "take_stakeholders_perspectives_ss5_6",
            "label": "Take stakeholders’ perspectives on issues, developments, or events by making inferences about their beliefs, values, and motivations"
          }
        ],

        "ethical_judgement": [
          {
            "value": "make_ethical_judgments_responses_ss5_6",
            "label": "Make ethical judgments about events, decisions, or actions that consider the conditions of a particular time and place, and assess appropriate ways to respond"
          }
        ]
      }
    }
  }
,
 
  



    }
  }; 
  export default grade_5;